import { DropdownItemInterface } from "../models/interfaces/dropdown-item.interface";
import { RadioItemInterface } from "../models/interfaces/radio-item.interface";
import { StepperInterface } from "../models/interfaces/stepper-item.interface";
import { ChildrenCareControlEnum } from "../models/enum/children-care-control.enum";
import { HoldingTypeEnum } from "../models/enum/holding-type.enum";
import { ReasonEnum } from "../models/enum/reason.enum";
import { ResidentialStatusEnum } from "../models/enum/residential-status.enum";
import { SolicitorTypeEnum } from "../models/enum/solicitor-type.enum";
import { MaritalStatusEnum } from "../models/enum/marital-status.enum";
import { SexEnum } from "../models/enum/sex.enum";
import { NationalityCode } from "./code-converter";
import data from "./shared/options.json";
import { DemiseAdministratorDoc } from "../models/enum/demise-administrator-doc.enum";
import { FlatRoomTypeEnum } from "../models/enum/flat-room-type.enum";
import { IDTypeEnum } from "../models/enum/id-type.enum";
export let stepperItems: StepperInterface[] = [
  { id: 1, title: 'Eligibility', link: '/application-coo/stage-a/eligibility' },
  { id: 2, title: 'Financing', link: '/application-coo/stage-a/financing' },
  { id: 3, title: 'Conveyancing', link: '/application-coo/stage-a/conveyancing' },
  { id: 4, title: 'Upload Documents', link: '/application-coo/stage-a/upload-documents' },
  { id: 5, title: 'Review & Endorse', link: '/application-coo/stage-a/summary' },
];

export let stepperFinancialCalculatorItems: StepperInterface[] = [
  { id: 1, title: 'Check outstanding payments', link: '/application-coo/financial-calculator/check-outstanding-payment' },
  { id: 2, title: 'Mode of financing', link: '/application-coo/financial-calculator/mode-of-financing' },
  { id: 3, title: 'Estimated Fees', link: '/application-coo/financial-calculator/estimated-fees' },
  { id: 4, title: 'Summary', link: '/application-coo/financial-calculator/summary' },
];

export let stepperItemsStageD: StepperInterface[] = [
  { id: 1, title: 'Review of Application by HDB' },
  { id: 2, title: 'In-Principle Approval' },
  // { id: 3, title: 'Book Appointment' },
  { id: 4, title: 'Review Financial Plan' }
];


export let reasonDropdown:DropdownItemInterface[] = [
  {
    id: 1,
    title: "Change in Marital Status",
    value: ReasonEnum.marital_status_reason_value,
  },
  {
    id: 2,
    title: "Change in Financial Circumstances",
    value: ReasonEnum.financial_circumstances_reason_value,
  },
  {
    id: 3,
    title: "Demise of Current Owner(s)",
    value: ReasonEnum.demise_current_owner_reason_value,
  },
  {
    id: 4,
    title: "Loss of Singapore Citizenship / Permanent Resident Status",
    value: ReasonEnum.loss_of_citizenship_reason_value,
  },
  {
    id: 5,
    title: "Current Owner is Moving Out",
    value: ReasonEnum.owner_moving_out_reason_value,
  },
  {
    id: 6,
    title: "Health Reasons",
    value: ReasonEnum.health_reasons_reason_value,
  },
  
]

export let yesNoDropdownItem:DropdownItemInterface[] = [
  {
    id:1,
    title:"Yes",
    value:'yes',
  },
  {
    id:2,
    title:"No",
    value:'no',
  }
]

export let incomingOwnerCitizenshipDropdownItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"Singapore Citizen",
    value: ResidentialStatusEnum.citizen,
  },
  {
    id:2,
    title:"Singapore Permanent Resident",
    value: ResidentialStatusEnum.pr,
  },
  {
    id:3,
    title:"None of the above",
    value: ResidentialStatusEnum.not_applicable,
  },
]

export let sexDropdownItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"Male",
    value: SexEnum.male,
  },
  {
    id:2,
    title:"Female",
    value: SexEnum.female,
  },
  // // {
  // //   id:3,
  // //   title:"Unknown",
  // //   value: SexEnum.unknown,
  // // },
]

export let raceDropdownItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"Chinese",
    value: "C",
    // value: "CN",
  },
  {
    id:2,
    title:"Indian",
    value: "I",
    // value: "IN",
  },
  {
    id:2,
    title:"Malay",
    value: "M",
    // value: "MY",
  },
  {
    id:3,
    title:"Others",
    value: "O",
    // value: "XX",
  },
]

export let nationalityDropdownItems: DropdownItemInterface[] = NationalityCode.map((item, index)=> {
    return {
        id: Number(index + 1),
        title: item.description,
        value: item.code
    }
})

export let maritalStatusDropdownItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"Single",
    value: MaritalStatusEnum.single,
  },
  {
    id:2,
    title:"Married",
    value: MaritalStatusEnum.married,
  },
  {
    id:3,
    title:"Widowed",
    value: MaritalStatusEnum.windowed,
  },
  {
    id:4,
    title:"Divorced",
    value: MaritalStatusEnum.divorced,
  }
]

export let ownerChildrenCareItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"I do not have any children",
    value: ChildrenCareControlEnum.no_children,
  },
  {
    id:2,
    title:"I do not have any children below the age(s) of 21",
    value: ChildrenCareControlEnum.no_children_below_21,
  },
  {
    id:3,
    title:"I have full care and control of my children",
    value: ChildrenCareControlEnum.full_custody_children,
  },
  {
    id:4,
    title:"I have shared care and control of my children",
    value: ChildrenCareControlEnum.shared_control_children,
  },
  {
    id:5,
    title:"I do not have care and control of my children",
    value: ChildrenCareControlEnum.no_control_children,
  },
 
]

export let incomingOwnerRelatedToItems:DropdownItemInterface[] = [
  {
    id:1,
    title:"Owner Related To 1",
    value:"Owner Related To 1",
  },
  {
    id:2,
    title:"Owner Related To 2",
    value:"Owner Related To 2",
  }
]

export let incomingOwnerRelatedToAboveItems:DropdownItemInterface[] = data.incomingOwnerRelatedToAboveItems;


export let incomingOwnerRelatedToAboveItemsSubsequent:DropdownItemInterface[] = data.incomingOwnerRelatedToAboveItemsSubsequent;



export let proposedHousingTypeItems:DropdownItemInterface[] = [
  {
    id:1,
    title: "Joint Tenancy",
    value: HoldingTypeEnum.joint_tenancy,
  },
  {
    id:2,
    title: "Tenancy-in-common",
    value: HoldingTypeEnum.tenancy_in_common,
  }
]

export let solicitorTypeItems:DropdownItemInterface[] = [
  {
    id:1,
    title: "HDB",
    value: SolicitorTypeEnum.hdb_solicitor,
  },
  {
    id:2,
    title: "Private Lawyer",
    value: SolicitorTypeEnum.private_solicitor,
  }
]

export let conveyancingSolicitorTypeItems:DropdownItemInterface[] = [
  {
    id:1,
    title: "HDB",
    value: SolicitorTypeEnum.conveyancing_hdb_solicitor,
  },
  {
    id:2,
    title: "Private Lawyer",
    value: SolicitorTypeEnum.conveyancing_private_solicitor,
  }
]

export let financialCalculatorFlatTypeItems: DropdownItemInterface[] = [
  {
    id: 1,
    title: "1-room",
    value: FlatRoomTypeEnum.room1
  },
  {
    id: 2,
    title: "2-room",
    value: FlatRoomTypeEnum.room2
  },
  {
    id: 3,
    title: "3-room",
    value: FlatRoomTypeEnum.room3
  },
  {
    id: 4,
    title: "4-room",
    value: FlatRoomTypeEnum.room4
  },
  {
    id: 5,
    title: "5-room",
    value: FlatRoomTypeEnum.room5
  },
  {
    id: 6,
    title: "Executive/ Multi-generational",
    value: FlatRoomTypeEnum.executive
  },
]

export let idTypesInterface: DropdownItemInterface[] = [
  {
    id: 1,
    title: "NRIC Number",
    value: IDTypeEnum.uinfin,
    isShown: true,
  },
  {
    id: 2,
    title: "FIN",
    value: IDTypeEnum.foreign_id,
    isShown: true,
  },
  {
    id: 3,
    title: "Passport Number",
    value: IDTypeEnum.passport,
    isShown: true,
  },
  {
    id: 4,
    title: "Special Pass Number",
    value: IDTypeEnum.special_pass,
    isShown: true,
  },
  {
    id: 5,
    title: "Malaysian Identification Card Number",
    value: IDTypeEnum.malaysian_id,
    isShown: true,
  },
  {
    id: 6,
    title: "Foreign Birth Certificate Number",
    value: IDTypeEnum.foreign_birth_cert,
    isShown: true,
  },
  {
    id: 7,
    title: "Other ID",
    value: IDTypeEnum.other_id,
    isShown: false,
  },
]


export class DemiseCurrentOwner{
  static reasonFieldName:string = "has_administration_items";
  static dropdownSelection:RadioItemInterface[] = [
    {
      id:1,
      description:"Yes, I have the Schedule of Assets, Grant of Probate and Last Will",
      value: DemiseAdministratorDoc.grant_probate_with_last_will,
      variant: "default"
    },
    {
      id:2,
      description:"Yes, I have the Schedule of Assets and Letter of Administration",
      value: DemiseAdministratorDoc.letter_of_administration,
      variant: "default"
    },
    {
      id:3,
      description:"No, I do not have the above documents",
      value: DemiseAdministratorDoc.no_document,
      variant: "default"
    }
  ]
  static beneficiariesProposedOwners:RadioItemInterface[] = [
    {
      id:1,
      description:" Yes, all the beneficiaries are the new proposed owners",
      value: "true",
      variant: "default"
    },
    {
      id:2,
      description:"No, it is not in accordance with the Will or Letter of Administration",
      value: "false",
      variant: "default"
    }
  ]
}

